import { createGlobalStyle } from 'styled-components/macro'
import { mq } from './mq'
import { theme } from './theme'

export const GRID_SIZE = 8 * 0.997
export const GRID_GAP = 2.5 * 0.997

export const GlobalStyle = createGlobalStyle`
:root {
  --header-height: 6rem;
  --container-spacing: 2rem;
  --text-color: white;
  --background-color: #0A0E0E;
  --accent-color: ${theme.colors.accent.rfe};
  --grid-size: ${(1 / 17) * 100}vw;
  --gap-size: ${(1 / 17) * 100}vw;
}

${mq.small} {
  :root {
    --container-spacing: var(--gap-size);
  }
}

${mq.medium} {
  :root {
    --grid-size: ${(58 / 744) * 100}vw;
    --gap-size: ${(26 / 744) * 100}vw;
    --header-height: 8rem;
    --container-spacing: ${(50 / 744) * 100}vw;
  }
}

${mq.large} {
  :root {
    --header-height: 10rem;
    --container-spacing: ${(50 / 1024) * 100}vw;
    --grid-size: ${(94 / 1024) * 100}vw;
    --gap-size: ${(25 / 1024) * 100}vw;
  }
}

${mq.extraLarge} {
  :root {
    --container-spacing: ${((GRID_SIZE + GRID_GAP) / 144) * 100}vw;
    --grid-size: ${(GRID_SIZE / 144) * 100}vw;
    --gap-size: ${(GRID_GAP / 144) * 100}vw;
  }
}


html {
  height: 100%;
  font-size: 62.5%;
}

body {
  margin: 0;
  overflow-x: hidden;
  font-family: ${theme.fonts.base},
    sans-serif;
  min-height: 100%;
  width: 100vw;
  font-size: 1.6rem;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-tap-highlight-color: transparent;
  color: var(--text-color);
  background-color: var(--background-color);

  ${mq.medium} {
    font-size: 1.8rem;
  }
}

*, *::before, *::after {
  box-sizing: border-box;
}

body.locked {
  overflow: hidden;
}

#root {
  display: contents;

  > * {
    flex-shrink: 0;
  }
}

a {
  color: var(--accent-color);
  text-decoration: none;
}

.underline a {
  border-bottom: 1px solid var(--accent-color);
}
`
